import { createSlice, PayloadAction } from '@reduxjs/toolkit';
 
interface SubChartAccountsState {
 
  SubChartAccountsArrayList: any[]
   
}

const initialState: SubChartAccountsState = { 
  SubChartAccountsArrayList:[]
};

const subChartAccountsTableSlice = createSlice({
  name: 'subChartAccountsTable',
  initialState,
  reducers: {
    // Action to store login details
    setSubChartAccountsDetails: (state, action: PayloadAction<Partial<SubChartAccountsState>>) => {
      return { ...state, ...action.payload };
    },
    // Action to reset subChartAccounts details (used only when logging out)
    resetSubChartAccountsDetails: () => initialState,
    // Action to set error message, if needed
    setSubChartAccountsError: (state, action: PayloadAction<string>) => {
      // Optionally, you can handle error state here
    },
  },
});

export const { setSubChartAccountsDetails, resetSubChartAccountsDetails, setSubChartAccountsError } = subChartAccountsTableSlice.actions;
export default subChartAccountsTableSlice.reducer;
